import { LanguageID } from "configs";
import { loadLocalStorage } from "utils";

export const getLanDefault = (): LanguageID => {
  const lanFromLocalStorage = loadLocalStorage("lan");
  if (
    lanFromLocalStorage &&
    Object.values(LanguageID).includes(lanFromLocalStorage as LanguageID)
  ) {
    return lanFromLocalStorage as LanguageID;
  }
  return LanguageID.vi;
};

/**
 * @deprecated Use i18n.t() with keys from en.json/vi.json for static strings. Only use initLanContent for runtime dynamic backend values.
 */
export const initLanContent = (
  e: Record<LanguageID, string> | string[]
): string => {
  const lan = getLanDefault();
  if (Array.isArray(e)) {
    return e[lan === LanguageID.vi ? 0 : 1];
  }
  return e[lan] || "";
};
